import React from 'react';

import { TextInput } from 'components/uikit/Form/TextInput/TextInput';
import { VOID_FUNCTION } from 'constants/index';

import { useTextInputMaskedPresenter } from './TextInputMasked.presenter';

export const TextInputMasked = ({
  name,
  value = '',
  mask,
  unmask = true,
  onChange = VOID_FUNCTION,
  onComplete = VOID_FUNCTION,
  onBlur = VOID_FUNCTION,
  ...rest
}) => {
  const presenter = useTextInputMaskedPresenter({
    mask,
    unmask,
    name,
    value,
    onChange,
    onComplete,
    onBlur,
  });

  return (
    <TextInput
      inputRef={presenter.ref}
      name={name}
      value={presenter.value}
      unmask={unmask}
      onClear={presenter.clearHandler}
      onBlur={presenter.blurHandler}
      {...rest}
    />
  );
};
